import './left-side-nav/left-side-nav.component';
import './left-side-nav/left-side-nav.scss';

import './right-side-nav/right-side-nav.component';
import './right-side-nav/right-side-nav.scss';

import './root/root-component.component';
import './root/root-component.scss';

import './site-main-view/site-main-view.component';
import './site-main-view/site-main-view.scss';

import './top-nav-main/top-nav-main.component';
import './top-nav-main/top-nav-main.scss';

import './top-nav-site/top-nav-site.component';
import './top-nav-site/top-nav-site.scss';

import './welcome-main-view/welcome-main-view.component';
import './welcome-main-view/welcome-main-view.scss';

import './organization-main-view/organization-main-view.component';
import './organization-main-view/organization-main-view.scss';
